import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import contactClasses from './contactStyles'


function ContactInformation() {
  const globalClasses = globalUseStyles()
  const contactStyles = contactClasses()
  return (
<ThemeProvider theme={theme}>
  <Container className={"connectStyle"} maxWidth={false} component="section">
    <Container className={"connectStyleInner"} maxWidth={false} component="section">
      <Grid item xs={12} md={12} className={globalClasses.containerVertPadding}>
        <Grid className={globalClasses.containerSmall} container >
          <Grid item xs={12} md={6} container>
            <Grid item xs={12} md={12} className={contactStyles.cityImg} />
          </Grid>
            <Grid className={globalClasses.textBlock} item xs={12} md={6} >
                <Typography className={contactStyles.contactInformation}  variant="h2">Pantheon</Typography>
                <Typography className={contactStyles.contactInformation}  variant="body1">703-387-4000</Typography>
                <Typography className={contactStyles.contactInformation}  variant="body1">2500 Wilson Blvd., Suite 200</Typography>
                <Typography className={contactStyles.contactInformation}  variant="body1">Arlington, VA 22201</Typography>
            </Grid>
        </Grid>
      </Grid>
    </Container>
  </Container>
</ThemeProvider>
  );
};

export default ContactInformation;